import * as React from 'react'

import { PlusIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import MapViewSetUpStore from '../../MapViewSetUp.store'
import UploadWhiteboardDialog from '../dialogs/UploadWhiteboardDialog/UploadWhiteboardDialog'

import './Ribbons.scss'

interface IProps {
  store: MapViewSetUpStore
  shouldHideAdditionMenu?: boolean
  shouldFixTopPosition?: boolean
  isCreateButtonHidden?: boolean

  shouldHideButton?: boolean
  shouldHideModals?: boolean
  shouldAvoidSitemapSelection?: boolean
}

@observer
export default class SitemapRibbon extends React.Component<IProps> {
  public render() {
    const {
      isCreateButtonHidden,
      store: { currentStep, sitemapControlStore },
      shouldHideButton,
      shouldHideModals,
    } = this.props
    const {
      toggleCreateWhiteboardMenu,
      shouldShowCreateWhiteboardMenu: shouldShowCreatePlanMenu,
    } = sitemapControlStore

    return (
      <>
        {!shouldHideButton && (
          <div className="sitemap-ribbon no-grow row">
            {!currentStep && !isCreateButtonHidden && (
              <>
                <div
                  className="text white bg-white brada24 py5 large title-row pointer row x-center ba-light-cool-grey"
                  onClick={toggleCreateWhiteboardMenu.bind(this)}
                >
                  <PlusIcon size={16} className="tw:text-primary" />
                </div>
              </>
            )}
          </div>
        )}
        {!shouldHideModals && shouldShowCreatePlanMenu && (
          <UploadWhiteboardDialog
            store={sitemapControlStore}
            mapViewItemsSetupStore={this.props.store.mapViewItemsSetupStore}
          />
        )}
      </>
    )
  }
}
